import { useEffect, useState, useContext, useCallback } from "react";
import { ErrorsValue } from "../../../contexts/errors";
import styles from "./styles.module.css";
import { MdWarning } from "react-icons/md";

export default function Errors({ setErrorId }) {
  const [open, setOpen] = useState(false);
  const errors = useContext(ErrorsValue);

  const handleElementClick = (error) => {
    setErrorId(error.actionId);
  };

  if (errors.workflows.length === 0) {
    return null;
  }
  return (
    <div className={styles.errors}>
      <div onClick={() => setOpen(!open)} className={styles.errorHeader}>
        <MdWarning size={24} />
        <div style={{ flexGrow: 1, marginLeft: 12 }}>
          {errors.workflows.length} Errors
        </div>
      </div>
      <div
        className={
          open ? styles.errorsList + " " + styles.open : styles.errorsList
        }
      >
        {errors.workflows.map((ee) => {
          return (
            <div
              key={ee.actionName + ee.actionerror}
              className={styles.errorItem}
              onClick={() => handleElementClick(ee)}
            >
              <div className={styles.errorWorkflow}>{ee.workflow}</div>
              <div className={styles.errorTitle}>{ee.actionName}</div>
              <div className={styles.errorDescription}>{ee.actionError}</div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
